import {
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
} from '@mui/material';

/**
 * Project aliases for MUI's Dialog family. Import `Dialog`, `DialogActions`,
 * and `DialogContent` from here instead of `@mui/material` so the whole app
 * tracks one dialog implementation. All MUI props pass through.
 */
const Dialog = props => <MUIDialog {...props} />;
const DialogActions = props => <MUIDialogActions {...props} />;
const DialogContent = props => <MUIDialogContent {...props} />;

export { Dialog, DialogActions, DialogContent };
